import { Notification } from '@/types/layout'

/**
 * Notifications hook
 * Returns empty array until real API integration is implemented
 */
export const useNotifications = (): Notification[] => {
  return []
}
